// extracted by mini-css-extract-plugin
export var figcaption_palette = "image_palette_post-module--figcaption_palette--2ecfa";
export var gatsby_image_wrapper = "image_palette_post-module--gatsby_image_wrapper--0dde9";
export var image_palette_post_wrapper = "image_palette_post-module--image_palette_post_wrapper--b5e49";
export var palette_codes = "image_palette_post-module--palette_codes--c44ae";